var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
var SvgResultSparkle3 = function SvgResultSparkle3(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 18 18"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    filter: "url(#result-sparkle-3_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#FFF1B0",
    d: "M9 4c.3 2.8 2.2 4.7 5 5-2.8.3-4.7 2.2-5 5-.3-2.8-2.2-4.7-5-5 2.8-.3 4.7-2.2 5-5"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)));
};
export default SvgResultSparkle3;